import React, { useState } from 'react';
import { UserRound } from 'lucide-react';

export default function WhatsAppSharedContact({ contact, onSave }) {
  const name = contact.name?.formatted_name || [contact.name?.first_name, contact.name?.last_name].filter(Boolean).join(' ') || 'Shared contact';
  const phones = (contact.phones || []).map(phone => phone.phone || (phone.wa_id ? `+${phone.wa_id}` : '')).filter(Boolean);
  const emails = (contact.emails || []).map(item => item.email).filter(Boolean);
  const [phoneNumber, setPhoneNumber] = useState(phones[0] || '');
  const [busy, setBusy] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState('');
  return <section aria-label={`Shared contact: ${name}`} className="w-60 max-w-full space-y-2 py-1">
    <div className="flex items-center gap-2"><UserRound aria-hidden="true" className="h-5 w-5 shrink-0 text-gray-500" /><p className="min-w-0 break-words text-sm font-semibold">{name}</p></div>
    {phones.map((phone, index) => <p key={index} className="break-words text-sm text-gray-600">{phone}</p>)}
    {emails.map((email, index) => <p key={index} className="break-all text-sm text-gray-600">{email}</p>)}
    {onSave && !saved && <>
      {phones.length > 1 && <label className="block text-xs">Number to save<select value={phoneNumber} onChange={event => setPhoneNumber(event.target.value)} disabled={busy} className="mt-1 w-full rounded-lg border p-2">{phones.map((phone,index) => <option key={index}>{phone}</option>)}</select></label>}
      <button type="button" disabled={busy} className="min-h-[44px] w-full rounded-lg border px-3 py-2 text-sm font-medium text-primary-700 disabled:opacity-50" onClick={async () => {
        setBusy(true); setError('');
        try { await onSave({ name, phoneNumber: phoneNumber || null, email: emails[0] || null }); setSaved(true); }
        catch (err) { setError(err?.response?.status === 409 ? 'This contact already exists or needs review. Check Contacts before adding it again.' : err?.response?.data?.error || 'Could not add contact. Please try again.'); }
        finally { setBusy(false); }
      }}>{busy ? 'Adding…' : 'Add to contacts'}</button>
    </>}
    {saved && <p role="status" className="text-xs text-green-800">Added to contacts</p>}
    {error && <p role="alert" className="text-xs text-red-800">{error}</p>}
  </section>;
}
